<template>
  <div class="confirm-payment" :class = "{'clear-header':isWechatBrowser}">
    <my-header class="top-title" v-if="!isWechatBrowser" title="确认支付" :showBack="true"></my-header>
    <div class="bill-list">
      <div class="bill-item" v-for="fee in projectStageFee" v-if="(fee.type != '3') || (fee.type == '3' && fee.priceStage > 0)">
        <div class="bill-info">
          <div class="bill-name" v-if="fee.percent">{{fee.name || '合同款'}}{{fee.percent * 100}}%</div>
          <div class="bill-name" v-if="!fee.percent">{{fee.name || '合同款'}}</div>
          <div class="bill-status-prepay" v-if="!fee.priceStage">等待工长发起</div>
          <div class="bill-status-prepay" v-if="fee.status == '0' && fee.priceStage">待支付</div>
          <div  class="bill-status-prepay" v-if="stageFee.id == fee.id && customerPayVoucher.stageFeeId == fee.id">{{payVoucherStatus}}</div>
          <div  class="bill-status-paid" v-if="fee.status == '1'">已支付</div>
        </div>
        <div class="bill-status-uncreate" v-if="!fee.priceStage">待生成</div>
        <div class="bill-amount" v-if="fee.priceStage">￥{{fee.priceStage}}</div>
      </div>
    </div>
    <div v-if="stageFee.payType == '1'" class="pay-mode">
      <div v-for="(payType,index) in payTypeList">
        <div @click="changePayType(index)" v-if="payType.key == 'WECHAT' && payType.status == '1'" >
          <div v-if="payType.selected" class="mode-row"><img class="icon" src="../../assets/clean/sex-yes.png">微信</div>
          <div v-if="!payType.selected" class="mode-row"><img class="icon" src="../../assets/icon/icon-unselected.png">微信</div>
        </div>
        <div v-if="payType.key == 'UPLOADVOUCHER' && payType.status == '1' && payTypeList.length == 1" >
          <div class="address-edit-form-item border-bottom-style" >
            <div class="form-title">业主支付金额</div>
            <input class="form-input" type="number" v-model="amount" placeholder="请输入项目款"/>
          </div>
          <div class="mode-row"><img class="icon" src="../../assets/icon/icon-selected.png">上传凭证</div>

          <div class="record-img">
            <div class="image-area">
              <div class="image-view">
                <div v-if="attachmentUrlList.length>0" v-for="(recoredImg,index) in attachmentUrlList">
                  <div class="image" style="position: relative">
                    <img :src="imgUrl+recoredImg" @click.stop="optionImage(index,$event)">
                  </div>
                </div>
                <div v-if="attachmentUrlList.length<5">
                  <div class="image add-image" @click.stop="addImage()">
                    <span class="icon-plus"><img src="../../assets/icon/icon-question-upload.png"></span>
                    <span style="display: none;"><input type="file" class="image-input" multiple accept="image/*"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div @click="changePayType(index)" v-if="payType.key == 'UPLOADVOUCHER' && payType.status == '1' && payTypeList.length == 2" class=" border-top-style">
          <div v-if="payType.selected" class="mode-row"><img class="icon" src="../../assets/icon/icon-selected.png">上传凭证</div>
          <div v-if="!payType.selected" class="mode-row"><img class="icon" src="../../assets/icon/icon-unselected.png">上传凭证</div>
          <div class="record-img">
            <div class="image-area">
              <div class="image-view">
                <div v-if="attachmentUrlList.length>0" v-for="(recoredImg,index) in attachmentUrlList">
                  <div class="image" style="position: relative">
                    <img :src="imgUrl+recoredImg" @click.stop="optionImage(index,$event)">
                  </div>
                </div>
                <div v-if="attachmentUrlList.length<5">
                  <div class="image add-image" @click.stop="addImage()">
                    <span class="icon-plus"><img src="../../assets/icon/icon-plus.png"></span>
                    <span style="display: none;"><input type="file" class="image-input" multiple accept="image/*"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mode-row border-top-style">
        <span class="row-money">金额：</span><span class="money">{{amount}}元</span>
      </div>
    </div>
    <div v-if="stageFee.payType == '3'" class="pay-mode">
      <div class="mode-row" style="justify-content: space-between;padding-top: 0.15rem">
        <div>业主支付金额</div>
        <div style="width: 2.4rem;height: 0.9rem;">
          <input v-model="amount" type="number" placeholder="请输入项目款" class="mint-field-core" style="height: 0.9rem;background-color: #f3f8fc;text-align: center">
        </div>
      </div>
      <div class="mode-row"><img class="icon" src="../../assets/icon/icon-selected.png">上传凭证</div>
      <div class="record-img">
        <div class="image-area">
          <div class="image-view">
            <div v-if="attachmentUrlList.length>0" v-for="(recoredImg,index) in attachmentUrlList">
              <div class="image" style="position: relative">
                <img :src="imgUrl+recoredImg" @click.stop="optionImage(index,$event)">
              </div>
            </div>
            <div v-if="attachmentUrlList.length<5">
              <div class="image add-image" @click.stop="addImage()">
                <span class="icon-plus"><img src="../../assets/icon/icon-question-upload.png"></span>
                <span style="display: none;"><input type="file" class="image-input" multiple accept="image/*"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mode-row border-top-style">
        <span class="row-money">金额：</span><span class="money">{{amount}}元</span>
      </div>
    </div>
    <div class="btns">
      <div class="cancel-btn" @click="goback()">取 消</div>
      <div v-if="payTypeSelected == 'WECHAT' && !isPay && customerProject.type != '2'" class="payment-btn" @click="sendWxPayOrder()">确认支付</div>
      <div v-if="(payTypeSelected == 'UPLOADVOUCHER' && !isPay)||customerProject.type == '2'" class="payment-btn" @click="savePayVoucher()">提交凭证</div>
      <div class="payment-btn" v-if="isPay">已支付</div>
    </div>
    <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>

    <div v-if="showBig" class="big-img-container" @click="hideImageView()">
      <img class="big-img"  :src="showImage">
      <div class="hidden-tip">轻触屏幕返回</div>
    </div>
  </div>
</template>

<script>
  import {imgUrl} from '../../config'
  import {Indicator, MessageBox, Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import session from '../../utils/Session'
  import projectService from '../../service/customer/ProjectService'
  import coreCodeService from '../../service/core/CodeService'
  import baseService from '../../service/BaseService'
  import payUtil from '../../utils/Pay'
  import customerPayVoucherService from '../../service/customer/CustomerPayVoucherService'

  export default {
    name: 'ConfirmPayment',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        projectId:'',
        imgUrl:imgUrl,
        onestopProject:{},
        stageFee:{},
        projectStageFee:[],
        payConfig:{},
        wxPayParams:{},
        isPay:false,
        codeCategory:'sysPayType',
        payTypeList:[],
        voucher:'',
        payTypeSelected:'WECHAT',
        sheetVisible:false,
        actions:[],
        showImage:'',
        showBig:false,
        customerProject:{tradeSettlement:{}},
        customerPayVoucher:{},
        payVoucherStatus:'',
        isWechatBrowser:this.$verfyBrowserType(),
        prePayInfo:{},
        amount:'',
        checkUserId:'',
        attachmentUrlList: []
      }
    },
    created(){
      this.projectId =this.$route.query.projectId;
      this.stageFeeType = this.$route.query.stageFeeType;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getProjectDetail();
      this.getSysPayType();
    },
    methods: {
      goback () {
        this.$router.go(-1);
      },
      async getProjectDetail(){
        let {code,data:onestopProject} = await projectService.getOnestopProjectDetail(this.projectId);
        if(code == '0'){
          console.info(onestopProject)
          this.onestopProject = onestopProject;
          if(this.stageFeeType == '2'){
            this.getProjectStageFee(this.onestopProject.foremanId);
            this.checkUserId = this.onestopProject.foremanId;
          }else if(this.stageFeeType == '6'){
            this.getProjectStageFee(this.onestopProject.designerId);
            this.checkUserId = this.onestopProject.designerId;
          }
        }else {
          Toast('获取项目详情失败，请稍后重试!');
        }
      },
      async getSysPayType(){
        let {code,msg,data} = await coreCodeService.getCodeList(this.codeCategory,'1');
        if(code == '0'){
          this.payTypeList = data;
          if(this.payTypeList.length>1){
            for(let i = 0;i < this.payTypeList.length;i++){
              if(i == 0){
                this.$set(this.payTypeList[i],'selected',true);
              }else {
                this.$set(this.payTypeList[i],'selected',false);
              }
            }
          }else {
            this.payTypeSelected = this.payTypeList[0].key;
          }
        }else {
          Toast('获取系统支付方式失败');
        }
      },
      async getProjectStageFee(supervisorId){
        var result = await projectService.getOnestopProjectStageFee(this.projectId,supervisorId);
        console.info('resu',result)
        if(result.code == 0){
          this.projectStageFee=result.data.projectStageFeeList;
          for(let psf of this.projectStageFee){
            if(psf.status != '1'){
              this.stageFee = psf;
              this.amount = this.stageFee.priceStage;
              break;
            }
          }
          if(this.stageFee.payType == '3'){
            this.payTypeSelected = 'UPLOADVOUCHER';
            let {code,msg,data} = await customerPayVoucherService.newest(this.projectId);
            if(code == '0'){
              this.customerPayVoucher = data;
              if(this.customerPayVoucher.checkStatus == '1'){
                this.payVoucherStatus = '凭证待审核';
              } else if(this.customerPayVoucher.checkStatus == '3'){
                this.payVoucherStatus = '凭证审核不通过';
              }
            }
          }
        }else {
          Toast('获取收费列表信息失败');
        }
      },
      changePayType(index){
        for (let payType of this.payTypeList){
          payType.selected = false;
        }
        this.payTypeList[index].selected = true;
        this.payTypeSelected = this.payTypeList[index].key;
      },
      async sendWxPayOrder(){
        //判断浏览器类型
        let ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger') {
          let browserType = '1';
          var result = await projectService.customerPay(this.projectId,session.getAccountToken().id,this.customerProject.type);
          if(result.code == '0'){
            this.prePayInfo = payUtil.pay(result.data.prepayId,result.data.nonceStr);
            let requestPay = this.requestPay;
            if (typeof WeixinJSBridge == "undefined"){
              if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', requestPay, false);
              }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', requestPay);
                document.attachEvent('onWeixinJSBridgeReady', requestPay);
              }
            }else{
              this.requestPay();
            }
          } else {
            Toast(result.msg);
          }
        }else {
          let browserType = '2';
          let result = await projectService.customerPay(this.projectId,session.getAccountToken().id,this.customerProject.type);
          if(result.code == '0'){
            let payCallBackUrl = result.data.mWebUrl + '&redirect_url=' + window.location.href;
            window.location.href = payCallBackUrl;
          }else {
            Toast(result.msg);
          }
        }
      },
      async savePayVoucher(){
        if(this.amount <= 0){
            Toast('请输入大于0的金额!');
            return false;
        }
        if(!this.voucher){
          Toast('请上传支付凭证!');
          return false;
        }
        if(this.voucher.substring(0,1) == ','){
            this.voucher = this.voucher.substring(1,this.voucher.length);
        }
        let customerPayVoucher = {projectId:this.projectId,projectType:this.stageFeeType,voucher:this.voucher,stageFeeId:this.stageFee.id,amount:this.amount,checkUserId:this.checkUserId};
        let {code,msg,data} = await customerPayVoucherService.save(customerPayVoucher);
        if(code == '0'){
          Toast('支付凭证提交成功!');
          this.$router.go(-1);
        }else {
          Toast(msg);
        }
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.$router.go(-1);
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                Toast('支付失败!');
                that.errorMsg = JSON.stringify(res)
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
      async addImage(){
        if(this.payTypeSelected != 'UPLOADVOUCHER'){
          Toast('请先选择上传凭证支付方式');
        }else {
          //小程序选择文件
          if(!!this.global.isMiniProgrm){
            baseService.uploadImageWxMini().then(res =>{
              baseService.downImage({mediaId:res}).then((data)=>{
                //处理image,key
                this.voucher = this.voucher + ',' +data.name;
                this.attachmentUrlList.push(data.name)
                Indicator.close();
              });

            }).catch(err =>{
              console.log("上传文件失败========",err);
              Indicator.close();
            });
          }else {
            //使用input文件选择
            let fileInput = document.querySelector(".image-input");
            fileInput.click();
            let that = this;
            fileInput.onchange = function(){
              let file = this.files[0];
              if(this.outerHTML){
                this.outerHTML=this.outerHTML;
              }else{      //FF
                this.value="";
              }
              Indicator.open({
                text: '加载中...',
                spinnerType: 'fading-circle'
              });
              lrz(file,{width: 1024,fieldName:'imgFile',quality:0.6}).then((rst) =>{
                return baseService.uploadImage(file);
              }).then((data) => {
                //处理image,key
                that.voucher = that.voucher + ',' +data.name;
                that.attachmentUrlList.push(data.name);
              }).catch((err) =>{
                console.log("上传文件失败========",err);
              }).always(()=>{
                Indicator.close();
              });
            }
          }
        }
      },
      optionImage(imageType,index){
        var that = this;
        this.actions = [
          {
            name: '查看',
            method: () =>{
              this.previewImage(imageType,index);
            }
          },
          {
            name: '删除',
            method: () =>{
              this.deleteImage(imageType,index);
            }
          }];
        this.sheetVisible = true;
      },
      deleteImage(){
        var that= this;
        MessageBox.confirm('确定要删吗？删除后将无法恢复。')
          .then((action) => {
            that.voucher = '';
          }).catch(e =>{
          console.error("删除图片出错：",e);
        });
      },
      previewImage(){
        this.showImage = imgUrl+this.voucher;
        this.showBig = true;
      },
      hideImageView(){
        this.showBig = false;
      },
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/common.scss';
  @import '../../assets/style/project-payment.scss';
</style>
